import React, { useState, useEffect } from "react";
import { ContentTable } from "./ContentTable";
import { useSelector, useDispatch } from "react-redux";
import { getListNguonVon, updateDataSearch } from "../../actions/NguonVon";
import { formatNumber } from "utils/currencyFormat";
import { BtnThemMoiGopVon } from "./ThemMoi/BtnThemMoiGopVon";
import Pagination from "react-js-pagination";

export const TableDanhSach = ({
  themmoinguonvon,
  quyenGopVon,
  quyenRutVon,
  quyenSuaNguonVon,
}) => {
  const dispatch = useDispatch();
  const listNguonVonFull = useSelector((state) => state.listNguonVonFull);
  const dataSearch = useSelector((state) => state.dataSearchNguonVon);
  useEffect(() => {
    dispatch(getListNguonVon(dataSearch));
  }, []);

  const handlePageChange = (pageNumber) => {
    dataSearch.pageIndex = pageNumber;
    dispatch(
      updateDataSearch({
        ...dataSearch,
        pageIndex: pageNumber,
      })
    );
    dispatch(getListNguonVon(dataSearch));
    loadNguonVon(dataSearch);
    //setpageNumber(pageNumber);
  };
  const loadNguonVon = () => {
    getListNguonVon(dataSearch);
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }; // set lên đầu page ví dụ khi phân trang
  return (
    <>
      <div
        className="card border-light mb-1 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
        }}
      >
        <div className="card-body card-body-v2">
          {themmoinguonvon && (
            <div className="iconbutton-new ">
              <div className="row">
                <div className="col-sm-12 col-md-9">
                  <BtnThemMoiGopVon />
                </div>
                <div className="col-sm-12 col-md-3 d-flex just-end"></div>
              </div>
            </div>
          )}
          <br />
          <div className="Left808x200 Table-main-new">
            <div className="loading-page1">
              <div
                className={
                  "loader loader-default " +
                  (listNguonVonFull.getListNguonVonLoading ? "is-active" : "")
                }
              ></div>
            </div>
            <div className="table-mobile sticky-table-bh2 table-mobile-hover">
              <div className="custom-table-wrapper">
                <div className="table-headers">
                  <div className="custom-table-header flex-basis-5 flex-basis-6-sm">
                    <p className="text-center">
                      STT
                      <br />{" "}
                      <span className="color-do-bold">
                        [ {listNguonVonFull.TongBanGhi} ]
                      </span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-26 flex-basis-23-6-sm">
                    <p className="text-center">Mã Cổ đông</p>
                  </div>

                  <div className="custom-table-header flex-basis-17 flex-basis-19-sm">
                    <p className="text-left">Cổ đông</p>
                  </div>

                  <div className="custom-table-header flex-basis-20 flex-basis-20-sm">
                    <p className="tab-header  text-center">Ngày</p>
                  </div>
                  <div className="custom-table-header flex-basis-11 flex-basis-12-8-sm">
                    <p className="tab-header  text-right">
                      Số tiền
                      <br />
                      <span className="color-xanh-bold">
                        {formatNumber(listNguonVonFull.TongTien)}
                      </span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-10 flex-basis-10-sm">
                    <p className="tab-header text-center">Tỷ lệ vốn</p>
                  </div>
                  <div className="custom-table-header flex-basis-11 flex-basis-8-6-sm action-cell">
                    <p className="tab-header">Chức năng</p>
                  </div>
                </div>
                <div className="custom-table-body">
                  <ContentTable
                    listNguonVonFull={listNguonVonFull.List}
                    quyenGopVon={quyenGopVon}
                    quyenRutVon={quyenRutVon}
                    quyenSuaNguonVon={quyenSuaNguonVon}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div
        className="card mb-3 border-light mb-1 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
        }}
      >
        <div className="card-body card-body-v2">
          <div className="row">
            <div className="col-sm-12  col-md-6">
              <span className="color7">
                Hiển thị{" "}
                {(listNguonVonFull.TongBanGhi === 0 ? "hidden" : "") == 0
                  ? "0"
                  : "1"}{" "}
                - {dataSearch.pageSize}/ Tổng số{" "}
                {listNguonVonFull.TongBanGhi === 0
                  ? "hidden"
                  : listNguonVonFull.TongBanGhi}
              </span>
            </div>
            <div className="col-sm-12  col-md-6">
              <div
                className={
                  "paniation-new paniation-new1 d-flex justify-content-center " +
                  (listNguonVonFull.TongBanGhi === 0 ? "hidden" : "")
                }
                style={{ float: "right" }}
              >
                <nav aria-label="Page navigation">
                  <Pagination
                    activePage={dataSearch.pageIndex}
                    itemsCountPerPage={dataSearch.pageSize}
                    totalItemsCount={listNguonVonFull.TongBanGhi}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    itemClass="page-item border-none"
                    linkClass="page-link border-none"
                    activeClass="active"
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
};
